(function () {
  'use strict';
  if (window.PSTInstalledExamples) return;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var motionAnimations = new Set();
  function entrance(element, distance, duration) {
    if (!element || reducedMotion.matches || !element.animate) return;
    element.getAnimations().forEach(function (animation) {
      if (motionAnimations.has(animation)) animation.cancel();
    });
    var animation = element.animate([
      { opacity: 0.35, transform: 'translateY(' + distance + 'px)' },
      { opacity: 1, transform: 'translateY(0)' }
    ], { duration: duration, easing: 'cubic-bezier(.2,.7,.2,1)' });
    motionAnimations.add(animation);
    animation.onfinish = animation.oncancel = function () { motionAnimations.delete(animation); };
  }
  reducedMotion.addEventListener('change', function () {
    if (reducedMotion.matches) motionAnimations.forEach(function (animation) { animation.cancel(); });
  });
  var revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      revealObserver.unobserve(entry.target);
      entrance(entry.target, 12, 520);
    });
  }, { threshold: 0.15 }) : null;
  function reveal() {
    document.querySelectorAll('.ps-finish-story__intro, [data-livery-track]').forEach(function (element) {
      if (element.dataset.motionReady) return;
      element.dataset.motionReady = 'true';
      if (revealObserver) revealObserver.observe(element);
    });
  }
  function init(examples) {
    if (!examples || examples.dataset.pstGalleryReady === 'true') return;
    var links = Array.from(examples.querySelectorAll('[data-pst-example-link][data-pst-media-kind="real-application"]'));
    if (!links.length) return;
    examples.dataset.pstGalleryReady = 'true';
    var dialog, image, caption, counter, previous, next, returnFocus, wasLocked, savedScroll, previousBodyStyle;
    var index = 0;
    function track(name) {
      var section = examples.closest('[data-ps-product-section]');
      var config = section && section.querySelector('[data-pst-dynamic-preview]');
      if (window.PSTAnalytics) window.PSTAnalytics.emit(name, {
        product_handle: config && config.dataset.pstProductHandle,
        colour: section && section.querySelector('[data-pst-selected]') && section.querySelector('[data-pst-selected]').textContent,
        image_label: links[index].dataset.pstCaption
      });
    }
    function show(number, navigated) {
      index = (number + links.length) % links.length;
      var thumbnail = links[index].querySelector('img');
      image.src = links[index].dataset.pstImageSrc;
      image.alt = thumbnail.alt;
      caption.textContent = links[index].dataset.pstCaption || '';
      counter.textContent = (index + 1) + ' / ' + links.length;
      previous.disabled = next.disabled = links.length < 2;
      if (navigated) track('real_application_image_next');
    }
    function makeButton(text, label) {
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = text;
      button.setAttribute('aria-label', label);
      button.className = 'ps-install-viewer__button';
      return button;
    }
    function createDialog() {
      dialog = document.createElement('dialog');
      dialog.className = 'ps-install-viewer';
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.setAttribute('aria-label', examples.dataset.galleryLabel || 'Installed application examples');
      var close = makeButton('×', examples.dataset.closeLabel || 'Close application photos');
      close.classList.add('ps-install-viewer__close');
      close.addEventListener('click', function () { dialog.close(); });
      image = document.createElement('img');
      image.className = 'ps-install-viewer__image';
      image.addEventListener('load', function () { entrance(image, 6, 240); });
      caption = document.createElement('p');
      caption.className = 'ps-install-viewer__caption';
      caption.setAttribute('aria-live', 'polite');
      counter = document.createElement('span');
      counter.className = 'ps-install-viewer__counter';
      var controls = document.createElement('div');
      controls.className = 'ps-install-viewer__controls';
      previous = makeButton('←', examples.dataset.previousLabel || 'Previous application photo');
      next = makeButton('→', examples.dataset.nextLabel || 'Next application photo');
      previous.addEventListener('click', function () { show(index - 1, true); });
      next.addEventListener('click', function () { show(index + 1, true); });
      controls.appendChild(previous);
      controls.appendChild(counter);
      controls.appendChild(next);
      dialog.appendChild(close);
      dialog.appendChild(image);
      dialog.appendChild(caption);
      dialog.appendChild(controls);
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          show(index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
        if (event.key === 'Tab') {
          var focusable = Array.from(dialog.querySelectorAll('button:not([disabled])'));
          var first = focusable[0], last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
      var touchStart;
      image.addEventListener('touchstart', function (event) { var t = event.touches[0]; touchStart = event.touches.length === 1 ? { x: t.clientX, y: t.clientY } : null; }, { passive: true });
      image.addEventListener('touchend', function (event) {
        if (!touchStart) return;
        var t = event.changedTouches[0], dx = t.clientX - touchStart.x, dy = t.clientY - touchStart.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) show(index + (dx < 0 ? 1 : -1), true);
        touchStart = null;
      }, { passive: true });
      dialog.addEventListener('close', function () {
        track('real_application_image_close');
        document.body.style.cssText = previousBodyStyle;
        window.scrollTo(0, savedScroll);
        if (!wasLocked) document.body.classList.remove('ps-no-scroll');
        if (returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
      });
      document.body.appendChild(dialog);
    }
    links.forEach(function (link, number) {
      link.addEventListener('click', function (event) {
        if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
        event.preventDefault();
        if (!dialog) createDialog();
        returnFocus = link;
        show(number);
        wasLocked = document.body.classList.contains('ps-no-scroll');
        savedScroll = window.scrollY;
        previousBodyStyle = document.body.style.cssText;
        document.body.style.position = 'fixed';
        document.body.style.top = -savedScroll + 'px';
        document.body.style.width = '100%';
        document.body.classList.add('ps-no-scroll');
        dialog.showModal();
        track('real_application_image_open');
        dialog.querySelector('.ps-install-viewer__close').focus({ preventScroll: true });
      });
    });
  }

  function strip(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var track = root.querySelector('[data-install-track]');
    var previous = root.querySelector('[data-install-previous]');
    var next = root.querySelector('[data-install-next]');
    var status = root.querySelector('[data-install-status]');
    var cards = Array.from(track.children);
    function update() {
      previous.disabled = track.scrollLeft < 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      var left = track.getBoundingClientRect().left;
      var active = cards.reduce(function (best, card, index) {
        return Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[best].getBoundingClientRect().left - left) ? index : best;
      }, 0);
      var right = track.getBoundingClientRect().right;
      var last = active;
      cards.forEach(function (card, index) {
        if (card.getBoundingClientRect().right <= right + 2 && index >= active) last = index;
      });
      status.textContent = (active + 1) + (last > active ? '–' + (last + 1) : '') + ' / ' + cards.length;
    }
    function move(direction) {
      var distance = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
      track.scrollBy({left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    previous.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    track.addEventListener('scroll', update, {passive: true});
    window.addEventListener('resize', update, {passive: true});
    root.querySelector('[data-install-controls]').hidden = false;
    update();
  }
  function carousel(root) {
    if (root.dataset.carouselReady) return;
    root.dataset.carouselReady = 'true';
    var track = root.querySelector('[data-livery-track]');
    var cards = Array.from(track.children);
    var status = root.querySelector('[data-livery-status]');
    var current = 0;
    var choices = [];
    function closest() {
      var left = track.getBoundingClientRect().left + parseFloat(getComputedStyle(track).paddingLeft || 0);
      return cards.reduce(function (best, card, index) {
        return Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[best].getBoundingClientRect().left - left) ? index : best;
      }, 0);
    }
    function update() {
      current = closest();
      status.textContent = (current + 1) + ' / ' + cards.length;
      choices.forEach(function (button, index) { button.setAttribute('aria-current', index === current ? 'true' : 'false'); });
    }
    function move(number) {
      var index = (number + cards.length) % cards.length;
      var padding = parseFloat(getComputedStyle(track).paddingLeft || 0);
      var position = track.scrollLeft + cards[index].getBoundingClientRect().left - track.getBoundingClientRect().left - padding;
      current = index;
      track.scrollTo({ left: position, behavior: 'instant' });
      entrance(cards[index], 6, 320);
      update();
    }
    var previousChoice = root.querySelector('[data-livery-previous]');
    var nextChoice = root.querySelector('[data-livery-next]');
    if (previousChoice) previousChoice.addEventListener('click', function () { move(current - 1); });
    if (nextChoice) nextChoice.addEventListener('click', function () { move(current + 1); });
    track.addEventListener('scroll', update, { passive: true });
    track.addEventListener('keydown', function (event) {
      if (event.target !== track) return;
      if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) < 0) return;
      event.preventDefault();
      move(event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1));
    });
    var down;
    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      down = { x: event.clientX, left: track.scrollLeft, moved: false };
    });
    track.addEventListener('pointermove', function (event) {
      if (!down || !event.buttons) return;
      if (Math.abs(event.clientX - down.x) > 8) down.moved = true;
      if (!down.moved) return;
      event.preventDefault();
      track.scrollLeft = down.left - (event.clientX - down.x);
    });
    track.addEventListener('dragstart', function (event) { event.preventDefault(); });
    track.addEventListener('click', function (event) { if (down && down.moved) { event.preventDefault(); down = null; } }, true);
    window.addEventListener('pointerup', function () { if (down && down.moved) move(closest()); });
    window.addEventListener('resize', update, { passive: true });
    var thumbnails = root.querySelector('[data-livery-thumbnails]');
    if (thumbnails) {
      cards.forEach(function (card, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', (index + 1) + ' / ' + cards.length + ': ' + card.querySelector('figcaption').textContent.trim());
        var thumbnail = document.createElement('img');
        var source = card.querySelector('img').src;
        thumbnail.src = source.indexOf('installation-stock-top-v1.webp') >= 0 ? source : source.replace(/\.webp(?=\?|$)/, '-thumb.webp');
        thumbnail.alt = '';
        thumbnail.width = 42;
        thumbnail.height = 56;
        thumbnail.loading = 'lazy';
        button.appendChild(thumbnail);
        button.addEventListener('click', function () { move(index); });
        choices.push(button);
        thumbnails.appendChild(button);
      });
      thumbnails.hidden = false;
    }
    var controls = root.querySelector('[data-livery-controls]');
    if (controls) controls.hidden = false;
    update();
  }
  function start() {
    document.querySelectorAll('[data-pst-installed-examples]').forEach(init);
    document.querySelectorAll('[data-install-strip]').forEach(strip);
    document.querySelectorAll('[data-livery-carousel]').forEach(carousel);
    reveal();
    document.querySelectorAll('[data-pst-piece-guide]').forEach(function (link) {
      if (link.dataset.ready) return;
      link.dataset.ready = 'true';
      link.addEventListener('click', function () {
        var target = document.querySelector(link.getAttribute('href'));
        if (target) target.open = true;
        var section = link.closest('[data-ps-product-section]');
        var config = section.querySelector('[data-pst-dynamic-preview]');
        if (window.PSTAnalytics) window.PSTAnalytics.emit('piece_sizes_how_it_works_click', { product_handle: config && config.dataset.pstProductHandle, colour: section.querySelector('[data-pst-selected]')?.textContent });
      });
    });
  }
  window.PSTInstalledExamples = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
}());
